import * as React from "react";
import { Typography } from "antd";
import Report6PreviewReportingPeriod from "./Report6PreviewReportingPeriod";
import { TReport6ApplicantPresentationModel } from "../../../presenter/report/model/Report6ApplicantPresentationModel";
import { TReport6ReportingPeriodPresentationModel } from "../../../presenter/report/model/Report6ReportingPeriodPresentationModel";

const Report6PreviewApplicant = ({
  translate,
  applicant
}: {
  translate: any;
  applicant: TReport6ApplicantPresentationModel;
}) => {
  const renderReportingPeriods = () => {
    let reportingPeriods: JSX.Element[] = [];
    applicant.reportingPeriods?.forEach(
      (reportingPeriod: TReport6ReportingPeriodPresentationModel) => {
        reportingPeriods.push(
          <Report6PreviewReportingPeriod
            key={`reporting-period-${reportingPeriod.reportingPeriodId}`}
            translate={translate}
            reportingPeriod={reportingPeriod}
          />
        );
      }
    );
    return reportingPeriods;
  };
  return (
    <div>
      <Typography.Title style={{ fontSize: 20, marginBottom: 10 }}>
        {`${translate("report6_preview_applicant.name_and_surname")}: ${
          applicant.fullName
        }`}
      </Typography.Title>
      {renderReportingPeriods()}
    </div>
  );
};

export default Report6PreviewApplicant;
